// @ts-nocheck
import React from "react";

// Components
import Hero from "../../components/Hero";
import Menu from "../../components/Menu";
import Partners from "../../components/Partners";
import PrivateCelebrations from "../../components/PrivateCelebrations";
import CarRentalFloat from "../../components/CarRentalFloat";
import { Footer } from "../../components/Footer";
import Gallery from "../../components/Gallery";
import TravelActivities from "../../components/TravelActivities";
import ActivitiesPopup from "../../components/ActivitiesPopup";
import CarRentalBanner from "../../components/CarRentalBanner";

// Business details and the menu come from the bundled snapshot in src/data,
// so there is nothing to validate or wait for before rendering.
const Home = () => {
    return (
        <div className="min-h-screen bg-cream selection:bg-gold selection:text-white">
            {/* Each section carries its own scroll anchor id (hero, menu,
                gallery, private-celebrations) — wrapping
                them in same-named divs duplicated those ids in the DOM. */}
            <Hero />
            <Menu />
            <TravelActivities />
            <CarRentalBanner />
            <ActivitiesPopup />
            <Partners />
            <Gallery />
            <PrivateCelebrations />

            <CarRentalFloat />
            <Footer />
        </div>
    );
};

export default Home;
